export const PostsSchedulePage = () => {
  return {
    submenu: (
      <div className="flex items-center justify-center h-full text-gray-400">
        <div className="text-center">
          <div className="text-sm">No submenu</div>
        </div>
      </div>
    ),
    mainContent: (
      <div className="flex items-center justify-center h-full bg-white">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Posts Schedule</h1>
          <p className="text-gray-600">Coming soon...</p>
        </div>
      </div>
    ),
  };
};
